<div #htmlRef class="aza-rw-popup-menu" [ngStyle]="menuCSS">
    <div class="aza-rw-popup-menu__container">
        <ng-container
            [ngTemplateOutlet]="templateRef"
            [ngTemplateOutletContext]="templateData"
        ></ng-container>
    </div>
</div>
